import { giphyLightGrey } from '@giphy/js-brand'
import React, { useContext, useEffect, useState } from 'react'
import { useKeyPress } from 'react-use'
import { fetchChannel } from 'shared/api/channels'
import UserContext from 'shared/components/context/user'
import CollectionsEditor from 'shared/components/edit-panel/collections-editor'
import { SearchBar } from 'shared/components/search-bar'
import { IChannel } from 'shared/types/channel'
import styled from 'styled-components'

const Container = styled.div`
    margin-bottom: 20px;
`

const Label = styled.label`
    color: ${giphyLightGrey};
    font-size: 14px;
    text-transform: capitalize;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
`
type Props = {
    showLabel?: boolean
    onChange: (data: { channelId: number | null }) => void
}
const Channels = ({ showLabel = true, onChange }: Props) => {
    const [selectedChannel, setSelectedChannel] = useState<IChannel | undefined>()
    const [isEscPressed] = useKeyPress((event: KeyboardEvent) => event.keyCode === 27)
    const onAdd = async (channelId: number) => {
        const channel = await fetchChannel(channelId)
        setSelectedChannel(channel)
        setCabinetSearchFocused(false)
        onChange({ channelId: channelId || null })
    }
    const [isCabinetSearchFocused, setCabinetSearchFocused] = useState<boolean>()
    useEffect(() => {
        if (isEscPressed && isCabinetSearchFocused) {
            setCabinetSearchFocused(false)
        }
    }, [isEscPressed, setSelectedChannel, isCabinetSearchFocused])
    const { user } = useContext(UserContext)
    const { curate_all_channels, curate_own_subchannels } = user?.permissions || {}
    const collectionsAllowed = curate_all_channels || curate_own_subchannels
    return collectionsAllowed ? (
        <Container>
            {showLabel && <Label>Collections</Label>}
            {isCabinetSearchFocused ? (
                <CollectionsEditor showPills={false} onAdd={onAdd} isSingleColumn />
            ) : (
                <SearchBar
                    onFocus={() => {
                        setSelectedChannel(undefined)
                        setCabinetSearchFocused(true)
                    }}
                    value={selectedChannel ? `Saving to your ${selectedChannel.display_name} collection` : undefined}
                />
            )}
        </Container>
    ) : null
}

export default Channels
